import React, {useState, useEffect} from 'react';
import './aboutUs.css'
import {Row, Col, Container, Image} from "react-bootstrap";
import IconCart from "../../components/accesories/carts/IconCart";
import OurTeam from "../../components/home/OurTeam";
import PageHeader from "../../layouts/home/PageHeader";
import CountUp from 'react-countup';
import {useInView} from 'react-intersection-observer';
import CustomAccordion from "../../components/accesories/accordian/CustomAccordion";
import {useData} from "../../context/DataContext";


function AboutUs(props) {

    const [aboutUsData, setAboutUsData] = useState([]);
    const [achievements, setAchievements] = useState([]);
    const [mainServices, setMainServices] = useState([]);
    const [subServices, setSubServices] = useState([]);
    const [teamMembers, setTeamMembers] = useState([]);

    const { data, fetchData, loading } = useData();
    const [ref, inView] = useInView({
        threshold: 1,
        triggerOnce: true
    });

    useEffect(() => {
        if (data.about_us.length === 0) {  // چک می‌کنیم که آرایه خالی نباشد
            fetchData("about_us", "about-us/");
        } else {
            setAboutUsData(data.about_us.about_us);
            setAchievements(data.about_us.achievements);
            setMainServices(data.about_us.main_services);
            setSubServices(data.about_us.sub_services);
            setTeamMembers(data.about_us.team_members);
            console.log(teamMembers)
        }
    }, [data.about_us]);
console.log( 'achivments: ',achievements)
    return (
        <>
            <PageHeader mainTitle={'با ما بیشتر آشنا شو'} currentPage={'درباره ما'}
                        navigationLinks={[{title: 'صفحه اصلی', href: '/'}]}/>

            <Container className={'about-company-container'}>
                <Row className={'d-flex align-items-center justify-content-center'}>
                    <Col sm={12} lg={6} className={'about-company-right-col'}>
                        <Image src={aboutUsData.image}/>
                    </Col>
                    <Col sm={12} lg={6} className={'about-company-left-col'}>
                        <h2>{aboutUsData.title}
                        </h2>
                        <p>{aboutUsData.description}</p>
                    </Col>
                </Row>
            </Container>
            <Container className={'about-us-expectations-container'}>
                <Row className={'expectations-up-row text-center'}>
                    <Col>
                        <h2>داپا؛ هر آنچه انتظار دارید...</h2>
                    </Col>
                </Row>
                <Row className={'expectations-down-row d-flex align-items-center justify-content-center'}>
                    {
                        achievements.map(achievement =>(
                            <Col key={achievement.id} sm={12} md={6} lg={3}
                                 className={'d-flex flex-column align-items-center justify-content-center'}>
                                <div ref={ref}
                                     className={'up-row flex-row d-flex justify-content-center align-items-center column-gap-3'}>
                                    <div className="f-icon">
                                        <i className={`flaticon-${achievement.icon}`}></i>
                                    </div>
                                    {inView && <p>+<CountUp start={0} end={achievement.number} duration={Math.random() * (7 - 4) + 4}/></p>}
                                </div>
                                <p className={'down-row'}>{achievement.title}</p>
                            </Col>
                        ))
                    }

                </Row>
            </Container>
            <Container className={'about-us-service-container'}>
                <Row>
                    <Col sm={12} xl={6} className={'right-col'}>
                        <h3>مهم ترین خدمات داپا
                        </h3>
                        <CustomAccordion items={subServices}/>
                    </Col>
                    <Col sm={12} xl={6}>

                        {
                            mainServices.length >= 4 &&
                            <>
                                <Row>
                                    <IconCart AOSEffect={'zoom-in'} className={'mt-5'} lg={6} xl={6} md={12}
                                              color={'rgb(255, 255, 255)'} icon={`flaticon-${mainServices[0].icon}`} header={mainServices[0].title}
                                              content={mainServices[0].description}/>

                                    <IconCart AOSEffect={'zoom-in'} className={'mb-3'} lg={6} xl={6} md={12}
                                              color={'rgb(255, 255, 255)'} icon={`flaticon-${mainServices[0].icon}`} header={mainServices[1].title}
                                              content={mainServices[1].description}/>


                                </Row>
                                <Row>
                                    <IconCart AOSEffect={'zoom-in'} className={'pt-0 mt-5'} lg={6} xl={6} md={12}
                                              color={'rgb(255, 255, 255)'} icon={`flaticon-${mainServices[2].icon}`} header={mainServices[2].title}
                                              content={mainServices[2].description}/>

                                    <IconCart AOSEffect={'zoom-in'} className={'pt-0'} lg={6} xl={6} md={12}
                                              color={'rgb(255, 255, 255)'} icon={`flaticon-${mainServices[3].icon}`} header={mainServices[3].title}
                                              content={mainServices[3].description}/>

                                </Row>
                            </>
                        }
                    </Col>
                </Row>
            </Container>
            <Container className={'about-us-our-team'}>
                <OurTeam teamMembers={teamMembers} header={'با چندتا از اعضای داپا'} span={'آشنا شو'}/>
            </Container>
        </>
    )
        ;
}

export default AboutUs;